import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { ActivatedRoute } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class AffiliateCidService {
  isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    public route: ActivatedRoute
  ) {}

  saveCid() {
    if (this.isBrowser) {
      const cid = this.route.snapshot.queryParamMap.get("cid");

      if (cid) {
        sessionStorage.setItem("cid", cid);
      }
    }
  }

  getCid() {
    if (this.isBrowser) {
      return sessionStorage.getItem("cid");
    }
    return null;
  }

  appendCidToUrl(url: string) {
    if (this.isBrowser) {
      const cid = this.getCid();
      const newUrl = new URL(url);

      if (cid) {
        newUrl.searchParams.append("affilliatecid", cid);
      }
      return newUrl.toString();
    }

    return url;
  }
}
